import React, { useContext, useState } from 'react';
import WizardFormBo from './WizardFormBo';

// *** Form Context Type
type WizardFormCtxType = {
    wizardFormBo: WizardFormBo,
    fireWizardFormBo: (prevState: WizardFormBo) => void,
    handleNextPage: () => void,
    handleBackPage: (backToStep?: number) => void,
}

// *** init Form Context
const ignoreValue: WizardFormCtxType = {
    wizardFormBo: new WizardFormBo(),
    fireWizardFormBo: prevState => { },
    handleNextPage: () => { },
    handleBackPage: (backToStep?: number) => { },

};

// *** Create Context
const WizardFormCtx = React.createContext<WizardFormCtxType>(ignoreValue);
const wizardFormInitBo = new WizardFormBo();

// *** Form Provider
export const WizardFormProvider: React.FC = ({ children }) => {

    // *************************
    // State Object / Operation
    // *************************    
    const [wizardFormBo, setWizardFormBo] = useState(wizardFormInitBo);

    const setWizardFormBoClone = (bo: WizardFormBo) => {
        setWizardFormBo({ ...bo });
    }

    const handleNextPage = () => {
        wizardFormBo.activeStep = wizardFormBo.activeStep + 1;
        setWizardFormBoClone(wizardFormBo)
    }

    const handleBackPage = (backToStep?: number) => {
        if (backToStep !== undefined && wizardFormBo.activeStep > backToStep) {
            wizardFormBo.activeStep = backToStep;
        } else {
            wizardFormBo.activeStep = wizardFormBo.activeStep - 1
        }
        setWizardFormBoClone(wizardFormBo)
    }

    return <WizardFormCtx.Provider value={{ wizardFormBo, fireWizardFormBo: setWizardFormBoClone, handleNextPage, handleBackPage }}>
        {children}
    </WizardFormCtx.Provider >
}

// *******************
// React Context
// *******************
const useWizardFormCtx = () => {
    return useContext(WizardFormCtx);
}

export default useWizardFormCtx;